import React from 'react';
import { PropTypes } from 'prop-types';
// logic
import { Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import routes from 'utils/routes';
// styles
import styled from 'styled-components';
// components
import OrdersComponent from 'components/orders/Orders';

const ActiveOrders = (props) => <OrdersComponent type="active" {...props} />;

const PreviousOrders = (props) => (
  <OrdersComponent type="previous" {...props} />
);
const RecurringOrders = (props) => (
  <OrdersComponent type="recurring" {...props} />
);

const SearchOrders = (props) => <OrdersComponent type="search" {...props} />;

const RedirectToOrders = () => <Redirect to={routes.orders.active} />;

const OrdersRoutes = ({ className, history }) => {
  return (
    <div className={className}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path={routes.orders.active} component={ActiveOrders} />
          <Route path={routes.orders.previous} component={PreviousOrders} />
          <Route path={routes.orders.recurring} component={RecurringOrders} />
          <Route path={routes.orders.search} component={SearchOrders} />
          <Route component={RedirectToOrders} />
        </Switch>
      </ConnectedRouter>
    </div>
  );
};

OrdersRoutes.propTypes = {
  className: PropTypes.string,
  history: PropTypes.any.isRequired,
};

export default styled(OrdersRoutes)`
  flex-grow: 1;
  height: 100%;
  overflow: auto;
  margin: 0 auto;
  max-width: 1146px;
  width: 100%;
`;
